import React from "react";
import { ButtonGroup, Col, Row, Button } from "react-bootstrap";
import { SearchAllColors } from "../../Utils/getAllColors";

const ColorButtons = ({
  product,
  language,
  colors,
  buttonClick,
  handleSelectImage,
}) => {
  const onTrigger = (s, i) => {
    buttonClick({ color: s, index: i });
  };

  const { colorHexArr, colorObjArr } = SearchAllColors(product);

  return (
    <ButtonGroup>
      <Row>
        {colorObjArr.map((s, i) => {
          const isSelected = colorObjArr[i] === colors;
          return (
            <Col
              key={i}
              xs={1}
              md={1}
              lg={1}
              className="mx-2 my-1"
              onClick={() => handleSelectImage(i)}
            >
              <Button
                variant={isSelected ? "primary" : "secondary"}
                style={{
                  width: "30px",
                  height: "30px",
                  backgroundColor: `${colorHexArr[i]}`,
                  padding: "6px 0px",
                  borderRadius: "15px",
                  textAlign: "center",
                  fontSize: "12px",
                  lineHeight: "1.42857",
                  marginTop: isSelected ? "5px" : "0px", // Pushes selected button down
                  transition: "margin 0.2s ease-in-out", // Smooth animation
                }}
                onClick={() => onTrigger(s, i)}
              ></Button>
            </Col>
          );
        })}
      </Row>
    </ButtonGroup>
  );
};

export default ColorButtons;
